import React from 'react';
import { Button } from '@getgrover/ui';
import PropTypes from 'prop-types';

import { LayoutComponent_Text as LegacyText } from 'ggApp/modules/layout';
import { Translator } from 'ggApp/modules/translator';

import getPaymentRedirectNotice from '../paymentRedirectNotice';
import { StyledPaymentMessage } from './styles';

const RedirectFormUi = ({ gateway, formErrorState, isFormSubmitting }) => {
    const translationValues = {
        gatewayName: gateway && gateway.name,
    };
    const noticeTK = getPaymentRedirectNotice(gateway);

    return (
        <>
            <StyledPaymentMessage>
                {!formErrorState && (
                    <LegacyText>
                        <Translator tk={noticeTK} withValues={translationValues} />
                    </LegacyText>
                )}
                {formErrorState && (
                    <LegacyText error>
                        <Translator tk={formErrorState} withValues={translationValues} />
                    </LegacyText>
                )}
            </StyledPaymentMessage>
            <Button primary fullWidth loading={isFormSubmitting} type="submit">
                <Translator tk="REDIRECT_FORM_SUBMIT_BUTTON_LABEL" withValues={translationValues} />
            </Button>
        </>
    );
};

RedirectFormUi.propTypes = {
    gateway: PropTypes.shape({
        name: PropTypes.string,
    }).isRequired,
};

export default RedirectFormUi;
